import { createContext, ReactNode, useContext } from "react";
import { HeaderDashboardStoreInterface } from "../model/HeaderDashboardStore.model";
import useHeaderDashboardStore from "../lib/HeaderDashboard.store";

const HeaderDashboardContext = createContext<HeaderDashboardStoreInterface | null>(null);

export const HeaderDashboardProvider = ({ children }: { children: ReactNode }) => {
  const store = useHeaderDashboardStore();
  return (
    <HeaderDashboardContext.Provider value={store}>
      {children}
    </HeaderDashboardContext.Provider>
  );
};

export const useHeaderDashboardContext = () => {
  const ctx = useContext(HeaderDashboardContext);
  if (!ctx) throw new Error("useHeaderDashboardContext must be used within HeaderDashboardProvider");
  return ctx;
};